import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import StatsSection from './components/StatsSection';
import ProjectsSection from './components/ProjectsSection';
import LocationsSection from './components/LocationsSection';
import BlogSection from './components/BlogSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  useEffect(() => {
    // Set page title and meta description
    document.title = 'İstanbul Fiber Optik Kablo Tamiri ve Güvenlik Sistemleri | Fiber Ek';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İstanbul, Kocaeli, Gebze, Tuzla ve çevre illerde 7/24 profesyonel fiber optik kablo tamiri, fiber sonlandırma, OTDR test, IP kamera, hırsız alarm, yangın alarm sistemleri kurulumu. Acil fiber arıza müdahalesi ve kurumsal güvenlik çözümleri.');
    }

    // Add canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://fiberek.com'}/`);

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'İstanbul Fiber Optik ve Güvenlik Sistemleri | 7/24 Acil Servis' },
      { property: 'og:description', content: 'Profesyonel fiber optik kablo tamiri, sonlandırma ve güvenlik sistemleri kurulumu. İstanbul ve çevre illerde 7/24 hizmet.' },
      { property: 'og:url', content: `${import.meta.env.VITE_SITE_URL || 'https://fiberek.com'}/` },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: 'tr_TR' },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    // Add LocalBusiness JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'homepage-schema';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Fiber Ek',
      image: `${import.meta.env.VITE_SITE_URL || 'https://fiberek.com'}/og-image.jpg`,
      description: 'İstanbul ve çevre illerde profesyonel fiber optik kablo tamiri, sonlandırma, OTDR test ve güvenlik sistemleri kurulumu hizmeti',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'İstanbul',
        addressRegion: 'İstanbul',
        addressCountry: 'TR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 41.0082,
        longitude: 28.9784,
      },
      url: import.meta.env.VITE_SITE_URL || 'https://fiberek.com',
      telephone: '+905537165561',
      priceRange: '$$',
      openingHoursSpecification: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '00:00',
        closes: '23:59',
      },
      areaServed: [
        'İstanbul', 'Kocaeli', 'Gebze', 'Tuzla', 'Dilovası', 'Çayırova',
        'Sakarya', 'Yalova', 'Bursa', 'Tekirdağ', 'Çorlu', 'Ataşehir',
        'Kadıköy', 'Ümraniye', 'Esenyurt', 'Başakşehir', 'Pendik', 'Kartal',
        'Beylikdüzü',
      ],
    });
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const schemaScript = document.getElementById('homepage-schema');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-dark-950">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <StatsSection />
        <ProjectsSection />
        <LocationsSection />
        <BlogSection />
        <CTASection />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}